<template>

  <div class="amccontract-update-page">
    <!--  credit form component -->

    <AmcContractForm
      v-on:onSubmit="onSubmit($event)"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      page="update"
    >
      <!-- footer block -->
      <template slot="footer"></template>
    </AmcContractForm>
  </div>
</template>

<script>
import AmcContractForm from "@/components/Form/Amc/AmcContractForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
export default {
  name: "AmcContractUpdate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    AmcContractForm
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("amccontract/updateList", {
          id: this.$route.params.id,
          field: data
        })
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          var message;
          if (this.status_code == 200) {
            //  show if invoice successfully created
             message = this.status_message;
              if(this.RoutePermission(true,'AmcContractView','','','')){
            this.$router.push({
              name: "AmcContractView",
              params:{id:this.updated_id}
            });
            }
            else{
               this.$router.push({
              name: "AmcContract"
               });
            }
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: "success",
              showCloseButton: true
            });
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("amccontract/fetchamccontractdetails").then(() => {
      store
      .dispatch("settings/fetchinvoicesettings", {
       stg_menu: "AMC Contract",
        stg_name: "amc_settings_details"
      });
      next();
    });
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.amccontract.code,
      updated_id: state => state.amccontract.updated_id,
      list: state => state.amccontract.Updatelist,
      status_code: state => state.amccontract.status_code, 
      status_message: state => state.amccontract.status_message, 
      status_type: state => state.amccontract.status_type
    })
  }
};
</script> 

<style>
</style>
